import { ID } from '@ianesthesie-kit/services';
import { groupBy, valueOfEnum } from '@ianesthesie-kit/core';
import { ConsultationStat, ConsultationStatCode } from './consultation.model';
import { ListMedicalService } from '../baseMedical.service';
import { GroupFunction, singlize } from '@/util';

export class ConsultationStatService extends ListMedicalService<ConsultationStat> {
  private static INSTANCE_BY_ID: ConsultationStatService;

  private constructor(patientId: string) {
    super('/consultation-stat', patientId);
  }

  public static getInstance(patientId: ID): ConsultationStatService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new ConsultationStatService(patientId);
    }
    return this.INSTANCE_BY_ID;
  }

  protected getGroupingFunction<K extends string, L extends boolean>(): {
    apply: GroupFunction<ConsultationStat, K, L>;
  } {
    return {
      apply: (data) => singlize(groupBy(data, 'code'))
    };
  }

  protected transformResponseEntity(data: any): ConsultationStat {
    return {
      ...super.transformResponseEntity(data),
      code: valueOfEnum(data.code, ConsultationStatCode, {
        throwIfNotFound: false,
        caseSensitive: false,
        defaultValue: data.code
      })!
    };
  }
}
